import Link from "next/link";
import { useFestivalExperience } from "./FestivalExperienceContext";
import { festivalThemeStyle } from "@/commons/festivalExperience/designPresets";
import { DiyaIcon } from "./FestivalOrnaments";
import FestivalPoojaCard from "./FestivalPoojaCard";

const SLOT = "pdp.related";

// PDP cross-link (PRD §4). Rendered after packages / Book Now / Get a Quote,
// never above them. "Context beats decoration": it only appears on a pooja
// that is itself part of the active festival, and shows the *other* mapped
// poojas — a Griha Pravesh page stays about Griha Pravesh during Navratri.
const RelatedFestivalPoojas = ({ currentPoojaSlug = "" }) => {
  const { experience } = useFestivalExperience();
  if (!experience?.primaryCampaign || !currentPoojaSlug) return null;

  const all = experience.poojas || [];
  if (!all.some((p) => p.slug === currentPoojaSlug)) return null;
  const poojas = all.filter((p) => p.slug !== currentPoojaSlug).slice(0, 3);
  if (!poojas.length) return null;

  const { primaryCampaign, activeDay, copy } = experience;
  return (
    <section
      style={festivalThemeStyle(primaryCampaign.themePreset, activeDay?.color)}
      data-fx-impression={SLOT}
      className="mx-6 my-6 md:mx-0 rounded-2xl bg-[hsl(var(--fx-bg))] p-4 md:p-5 text-[hsl(var(--fx-fg))]"
    >
      <div className="mb-3 flex items-center gap-2.5">
        <DiyaIcon className="h-5 w-5 shrink-0" />
        <h3 className="font-playfair text-lg font-bold !text-[hsl(var(--fx-fg))]">Also this {primaryCampaign.festivalName}</h3>
        <Link href={primaryCampaign.landingHref} data-fx-slot={SLOT} className="ml-auto shrink-0 font-sans text-xs font-semibold text-[hsl(var(--fx-accent))] hover:underline">
          {activeDay ? `${activeDay.label} · See all` : copy.cta || "See all"} →
        </Link>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        {poojas.map((p, i) => (
          <FestivalPoojaCard key={`${p.slug}-${p.linkLocation || ""}-${p.linkLanguage || ""}`} pooja={p} slotKey={SLOT} rank={i + 1} compact />
        ))}
      </div>
    </section>
  );
};

export default RelatedFestivalPoojas;
